export default "__VITE_ASSET__a50fde46__"